class AtmFooterNewsletter {
  constructor(form) {
    this.form = form;
    this.status = form.querySelector('[data-atm-newsletter-status]');
    this.email = form.elements.email;
    this.consent = form.elements.consent;
    this.submit = form.querySelector('[type="submit"]');
    form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  message(name) {
    return this.form.querySelector(`[data-atm-newsletter-${name}]`)?.textContent.trim() || '';
  }

  setStatus(message, state) {
    this.status.textContent = message;
    this.status.dataset.state = state;
    this.status.focus({ preventScroll: true });
  }

  fields() {
    const url = new URL(window.location.href);
    const values = {
      email: this.email.value.trim(),
      airteam_locale: this.form.dataset.locale,
      airteam_market: this.form.dataset.market,
      airteam_page_url: url.href,
    };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((name) => {
      const value = url.searchParams.get(name);
      if (value) values[name] = value;
    });
    return Object.entries(values).map(([name, value]) => ({ name, value }));
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.status.textContent = '';
    if (!this.email.validity.valid) {
      this.email.focus();
      this.setStatus(this.message('invalid'), 'error');
      return;
    }
    if (!this.consent.checked) {
      this.consent.focus();
      this.setStatus(this.message('consent'), 'error');
      return;
    }

    const portalId = this.form.dataset.portalId;
    const formGuid = this.form.dataset.formGuid;
    // Comma-separated: offers, avionics, safety (topics from 2026-10-29; the consent text covers all three).
    const subscriptionTypeIds = String(this.form.dataset.subscriptionTypeId || '')
      .split(',')
      .map(Number)
      .filter((id) => Number.isInteger(id) && id > 0);
    if (!portalId || !formGuid || !subscriptionTypeIds.length) {
      this.setStatus(this.message('unavailable'), 'error');
      return;
    }

    const consentText = this.form.dataset.consentText;
    const context = { pageUri: window.location.href, pageName: this.form.dataset.pageName };
    const hutk = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/)?.[1];
    if (hutk) context.hutk = decodeURIComponent(hutk);
    const payload = {
      fields: this.fields(),
      context,
      legalConsentOptions: {
        consent: {
          consentToProcess: true,
          text: consentText,
          communications: subscriptionTypeIds.map((subscriptionTypeId) => ({ value: true, subscriptionTypeId, text: consentText })),
        },
      },
    };

    this.submit.disabled = true;
    this.form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${encodeURIComponent(portalId)}/${encodeURIComponent(formGuid)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(`HubSpot form submission failed: ${response.status}`);
      this.form.reset();
      this.setStatus(this.message('success'), 'success');
    } catch (error) {
      this.setStatus(this.message('error'), 'error');
    } finally {
      this.submit.disabled = false;
      this.form.removeAttribute('aria-busy');
    }
  }
}

document.querySelectorAll('[data-atm-newsletter]').forEach((form) => new AtmFooterNewsletter(form));
document.querySelectorAll('[data-atm-cookie-settings]').forEach((button) => {
  button.addEventListener('click', () => {
    if (window.Shopify?.customerPrivacy?.showPreferences) {
      window.Shopify.customerPrivacy.showPreferences();
      return;
    }
    window.location.assign(button.dataset.fallbackUrl);
  });
});

const footerBreakpoint = window.matchMedia('(min-width: 750px)');
const syncFooterNavigation = () => {
  document.querySelectorAll('.atm-footer__nav').forEach((details) => { details.open = footerBreakpoint.matches; });
};
footerBreakpoint.addEventListener('change', syncFooterNavigation);
syncFooterNavigation();
